import {
  useGetUserPreferencesQuery,
  useSaveUserPreferencesMutation,
} from '@/store/api/userPreferences.api';
import { setUserPrefsToastStatus } from '@/store/toasts/globalToastsSlice';
import {
  savedToBackend,
  setPreferencesInitialLoadingStatus,
  setUserPreferences,
  userPreferences,
  userPreferencesInitialLoadingStatus,
  userPreferencesNeedToSave,
} from '@/store/user/userPreferencesSlice';

import { isDefined } from '@/utils/assertions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTimeout } from 'usehooks-ts';

export function UserPreferencesInitializer() {
  const dispatch = useDispatch();

  const { data: loadedPrefs, isLoading, isError, error } = useGetUserPreferencesQuery();
  useEffect(() => {
    if (isError) {
      dispatch(setPreferencesInitialLoadingStatus('error'))
    }
  }, [dispatch, isError, error]);

  useEffect(() => {
    if (isLoading || isError) {
      return;
    }

    dispatch(setPreferencesInitialLoadingStatus('loaded'));

    if (isDefined(loadedPrefs)) {
      dispatch(setUserPreferences(loadedPrefs));
    }
    // else : the user has no previously saved prefs, staying in default initial state
  }, [dispatch, loadedPrefs, isLoading, isError]);

  return null;
}

export function UserPreferencesUpdater() {
  const dispatch = useDispatch();
  const initialLoadingStatus = useSelector(userPreferencesInitialLoadingStatus);

  const needToSave = useSelector(userPreferencesNeedToSave);

  const userPrefs = useSelector(userPreferences);
  const [saveUserPreferences] = useSaveUserPreferencesMutation();

  useEffect(() => {
    if (initialLoadingStatus === 'error') {
      console.info(
        'Cannot save use prefs because we could not load the prefs in the first place, so we would overwrite user prefs with default data',
      );
      return;
    }
    if (initialLoadingStatus !== 'loaded' || !needToSave) {
      return;
    }
    saveUserPreferences(userPrefs)
      .unwrap()
      .then(() => {
        dispatch(savedToBackend());
        dispatch(setUserPrefsToastStatus('ok'))
      })
      .catch((error) => {
        console.error('Echec de la sauvgardage', error)
        dispatch(setUserPrefsToastStatus('nok'))
      })
  }, [userPrefs, needToSave, saveUserPreferences, initialLoadingStatus, dispatch]);

  return null;
}
